/**
 * TRANSACTIONS -- ENDPOINTS
 * @description
 * [ENDPOINTS] - This are the list of endpoints for the transactions module
 */
// eslint-disable-next-line
export const TRANSACTIONS = {
  FIND_ALL: 'transactions/findAll',
  FREE_PLAY_CONTRIBUTIONS: 'transactions/freeplay-contribution',
}
